import React, { Component } from 'react';
import { HeaderMain } from '../../Common/HeaderMain'
import { HeaderSub } from '../../Common/HeaderSub'
import { OrderStoreList } from './OrderStoreList';
import { OrderExcelList } from '../Excle/OrderExcelList';
import { OrderExcelTable } from '../Excle/OrderExcelTable';
import { Footer } from '../../Common/Footer'
import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능: 매장주문 Index
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.OrderStoreList,  //기본 컴포넌트 할당
            ContentState: null
        };
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //호출할 컴포넌트 이름
    CompName = {
        "OrderStoreList": "OrderStoreList",
        "OrderExcelList": "OrderExcelList",
        "OrderExcelTable":"OrderExcelTable"
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
         
        if (this.state.RenderName === this.CompName.OrderStoreList) {
            //스토어 주문
            return (
                <div>
                    <HeaderMain
                        HeaderSub={{ Title: this.Uid_Type === 'SS' ? "사입주문" : "택배주문", LinkYn: "N", LinkUrl: "", ComponentUrl: "" }}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                    <OrderStoreList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                    <Footer fillName="icon2" />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.OrderExcelList) {
            //엑셀 주문
            return (
                <div>
                    <HeaderMain
                        HeaderSub={{ Title: this.Uid_Type === 'SS' ? "사입주문" : "택배주문", LinkYn: "N", LinkUrl: "", ComponentUrl: "OrderStoreList" }}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                    <OrderExcelList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                    <Footer fillName="icon2" />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.OrderExcelTable) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle={this.Uid_Type === 'SS' ? "사입주문" : "택배주문"}
                        ComponentUrl="OrderExcelList"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ComponentName={this.state.RenderName}
                    />
                    <OrderExcelTable
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
